// src/components/UniversalTable.js

import LoadingSpinner from "../components/common/LoadingSpinner";

const UniversalTable = ({
  headers,
  data,
  isLoading = false,
  noDataText = "Записей не найдено",
  emptySearchText = "Ничего не найдено по вашему запросу",
  onRowClick,
  className = "table table-bordered table-striped-columns",
  isDisabled = false  // Новый параметр для управления состоянием disabled
}) => {
  // Если нет заголовков — ничего не рендерим
  if (!headers || headers.length === 0) {
    return <div className="text-center text-muted py-4">Нет данных для отображения</div>;
  }

  // Удаляем блок disabledHeaders так как он больше не нужен

  // Определяем, есть ли поиск у хотя бы одного заголовка
  const hasSearch = headers.some((h) => h.searchable);

  return (
    <div className="table-responsive">
      <table className={className}>
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th key={index}>
                {/* Сортировка */}
                {header.sortable ? (
                  <div
                    onClick={header.onSort}
                    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                  >
                    <span>{header.label}</span>
                    <span style={{ marginLeft: '8px', fontSize: '0.8em', opacity: 0.7 }}>
                      {header.sortDirection === 'asc' ? '▲' :
                       header.sortDirection === 'desc' ? '▼' :
                       '↕'}
                    </span>
                  </div>
                ) : (
                  <span>{header.label}</span>
                )}
                {header.filter && header.filter.type === 'select' && (
                  <>
                    <br />
                    <select
                      className="form-select form-select-sm mt-1"
                      value={header.filter.value || ''}
                      onChange={(e) =>
                        header.filter.onChange && header.filter.onChange(e.target.value)
                      }
                      disabled={isDisabled}
                    >
                      {/*<option value="">Все</option>*/}
                      {header.filter.options?.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </>
                )}
                {header.searchable && (
                  <>
                    <br />
                    <input
                      type="text"
                      className="form-control form-control-sm mt-1"
                      placeholder={header.searchPlaceholder || "Поиск"}
                      value={header.searchValue || ''}
                      onChange={(e) =>
                        !isDisabled && header.onSearchChange && header.onSearchChange(e.target.value)
                      }
                      onKeyDown={(e) => !isDisabled && header.onSearchKeyDown && header.onSearchKeyDown(e)}
                      onBlur={(e) => !isDisabled && header.onSearchBlur && header.onSearchBlur(e.target.value)}
                      disabled={isDisabled}
                    />
                  </>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={headers.length} className="text-center py-4">
                <LoadingSpinner text="Загружаем звонки..." />
              </td>
            </tr>
          ) : data.length === 0 ? (
            <tr>
              <td colSpan={headers.length} className="text-center text-muted py-4">
                <strong>{noDataText}</strong>
                {hasSearch && <br />}
                {hasSearch && <small>{emptySearchText}</small>}
              </td>
            </tr>
          ) : (
            data.map((row, rowIndex) => (
              <tr
                key={row.id || rowIndex}
                onClick={() => onRowClick && onRowClick(row)}
                style={{ cursor: onRowClick ? 'pointer' : 'default' }}
              >
                {headers.map((header, cellIndex) => (
                  <td key={cellIndex}>
                    {header.render
                      ? header.render(row)
                      : row[header.key] !== undefined
                      ? row[header.key]
                      : "—"}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UniversalTable;
